import React from 'react';
import { Col, Row } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faCode, faLaptopCode } from '@fortawesome/free-solid-svg-icons'
import { faDribbble } from '@fortawesome/free-brands-svg-icons'
const element = <FontAwesomeIcon icon={faDribbble} />
const code = <FontAwesomeIcon icon={faCode} />
const loptob = <FontAwesomeIcon icon={faLaptopCode} />

const Service = () => {
    return (
        <Row lg={3} md={2} xs={1}  className='mt-5 pb-5 g-4'>
            <Col>
                <div className="service-item ">
                    <div className="icon">
                        {element}
                    </div>
                    <h2>Web Design</h2>
                    <p>Responsive Web Design with HTML,CSS,Boostrap or Tailwind</p>
                </div>
            </Col>
            <Col>
                <div className="service-item ">
                    <div className="icon">
                        {code}
                    </div>
                    <h2>Web Developement</h2>
                    <p>Responsive design with developement using React.js and Node.js</p>
                </div>
            </Col>
            <Col>
                <div className="service-item ">
                    <div className="icon">
                        {loptob}
                    </div>
                    <h2>UI/UX Designer</h2>
                    <p>Design Web Ui and also based on user experience in Adobe XD or Figma</p>
                </div>
            </Col>
        </Row>
    );
};

export default Service;